declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xsMid: true
    smMid: true
    smClose: true
    lgMid: true
  }
}

export const breakpoints = {
  values: {
    xs: 0,
    xsMid: 500,
    sm: 600,
    smClose: 720,
    smMid: 750,
    md: 900,
    lg: 1200,
    lgMid: 1300,
    xl: 1536,
  },
}
